// extracted by mini-css-extract-plugin
module.exports = {"className":"hi-IN_className__iP2XM"};